import { CampaignViewModel } from 'app/viewModels/components/CampaignViewModel';
import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from '../common/Modal';
import { ApproveWindow } from '../common/ApproveWindow';
import { observer } from 'mobx-react-lite';
import { CampaignStatusTitle } from 'app/utils/campaignStatusHelpers';

type Props = {
    model: CampaignViewModel;
};

const modalDesc = 'Please note that changing the status will trigger an email notification to the user. This action cannot be undone.';


export const CampaignUpdateStatusModal = observer(({ model }: Props) => {
    const {
        onUpdateStatus,
        closeUpdateStatusModal,
        isUpdateModalActive,
        newCampaignStatus,
        isLoading,
    } = model;

    const modalTitle = useMemo(
        () => `Are you sure you want to change the status to ${CampaignStatusTitle[newCampaignStatus]}?`,
        [newCampaignStatus],
    );

    if (!isUpdateModalActive) {
        return null;
    }

    return (
        createPortal(
            <Modal onClose={closeUpdateStatusModal}>
                <ApproveWindow
                    onClickApprove={onUpdateStatus}
                    onClickCloseBtn={closeUpdateStatusModal}
                    cancelBtnText='Cancel'
                    approveBtnText='Change Status'
                    title={modalTitle}
                    desc={modalDesc}
                    isLoading={isLoading}
                />
            </Modal>,
            document.body,
        ) as React.ReactNode
    );
});
